module.exports = __webpack_public_path__ + "img/back3.da664aae.gif";